import { render, staticRenderFns } from "./CCMAllergyViewDialog.vue?vue&type=template&id=d3d0a7f6"
import script from "./CCMAllergyViewDialog.vue?vue&type=script&lang=js"
export * from "./CCMAllergyViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports